import { Moon, Sun } from "lucide-react"
import React from "react"
import { useTheme } from "../../contexts/ThemeContext"
import { cn } from "../../utils/cn"

/** Botão de alternância light/dark. Ícone reflete o tema para o qual troca. */
const ThemeToggle: React.FC<{ className?: string }> = ({ className }) => {
    const { theme, toggleTheme } = useTheme()
    const isDark = theme === "dark"

    return (
        <button
            onClick={toggleTheme}
            aria-label={isDark ? "Ativar tema claro" : "Ativar tema escuro"}
            title={isDark ? "Tema claro" : "Tema escuro"}
            className={cn(
                "inline-flex items-center justify-center rounded-full p-2 text-muted transition-colors",
                "hover:bg-elevated hover:text-text focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60",
                className
            )}
        >
            {isDark ? <Sun size={18} /> : <Moon size={18} />}
        </button>
    )
}

export default ThemeToggle
